import { createSlice, createSelector } from '@reduxjs/toolkit'
import qs from 'qs'

const initialState = {
  cachedQueries: {},
  loading: false,
  error: null,
  currentQuery: null,
}

const look = createSlice({
  name: 'look',
  initialState: initialState,
  reducers: {
    requestLook(state) {
      state.loading = true
      state.error = null
    },
    successLook(state, { payload }) {
      const { key, look, refresh = false } = payload
      const { cachedQueries } = state
      state.currentQuery = key
      if (!cachedQueries[key] || refresh) {
        cachedQueries[key] = look
      }
      state.loading = false
      state.error = null
    },
    failureLook(state, { payload }) {
      const { key, look, data } = payload
      state.currentQuery = key
      state.loading = false
      state.error = data || look
    },
  },
})

export const fetchLook = ({ refresh = false, errToString = true, ...params }) => async (dispatch, getState, { api }) => {
  const state = getState().look
  const key = qs.stringify(params)
  try {
    if (!refresh && state.cachedQueries[key]) {
      dispatch(successLook({ key }))
      return
    } else {
      dispatch(requestLook())
      const response = await api.look(params)
      const { result, look } = response
      if (result === 'success') {
        dispatch(successLook({ key, look, refresh }))
      } else {
        dispatch(failureLook({ key, data: response }))
      }
    }
  } catch (err) {
    dispatch(failureLook({ key, data: errToString ? err.toString() : err }))
  }
}

export const getLookDataByKey = params => state => {
  const key = qs.stringify(params)
  const look = state.look
  const { cachedQueries, currentQuery, ...lookState } = look

  const cachedQueryData = cachedQueries[key]

  return {
    data: cachedQueryData,
    ...lookState,
  }
}

export const { requestLook, successLook, failureLook } = look.actions

export default look.reducer
